import { React, useState, useEffect, useRef } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Dialog } from "primereact/dialog";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import ToastElement from "../../../../../Components/UiComponents/ToastElement";
import InputTextElement from "../../../../../Components/UiComponents/InputTextElement";
import SingleSelectElement from "../../../../../Components/UiComponents/SingleSelectElement";
import { updateContactFromPages } from "../../../../../Services/addressService";
import { getCustomerFields } from '../../../../../Services/fieldsServices';
import { getBranchUser } from '../../../../../Services/userService';
import { list } from '../../../../../Services/branchService';
import { getCustomerDetails } from '../../../../../Services/clientService';
import ButtonElement from "../../../../../Components/UiComponents/ButtonElement";
import RadioElement from "../../../../../Components/UiComponents/RadioElement";
import Loader from "../../../../../Components/UiComponents/Loader";

export default function EditContact(props) {
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
        setValue
    } = useForm();
    // const [errors, setErrors] = useState({});
    const [visible, setVisible] = useState(false);
    const [contacts, setContacts] = useState([]);
    const [titles, setTitles] = useState([
        { label: 'Mr.', value: 'Mr.' },
        { label: 'Mrs.', value: 'Mrs.' },
        { label: 'Ms.', value: 'Ms.' },
        { label: 'Miss.', value: 'Miss.' },
        { label: 'Mx.', value: 'Mx.' },
        { label: 'Dr.', value: 'Dr.' },
        { label: 'Prof.', value: 'Prof.' }
    ]);
    const [status, setStatus] = useState([
        { id: 0, label: 'Active', value: 'Active' },
        { id: 1, label: 'Inactive', value: 'Inactive' },
        { id: 2, label: 'Left The Company', value: 'Left The Company' }
    ]);
    const [addressDetails, setAddressDetails] = useState([]);
    const [businessUnit, setBusinessUnit] = useState([]);
    const [city, setCity] = useState([]);
    const [state, setState] = useState([]);
    const [postcode, setPostcode] = useState([]);
    const [country, setCountry] = useState([]);
    const [roles, setRoles] = useState([]);
    const [branchId, setBranchId] = useState(null);
    const [branchDetail, setBranchDetail] = useState([]);
    const [size, setSize] = useState(props?.contactDetail?.consent_accept);
    const toastRef = useRef();
    const [loading, setLoading] = useState(false)

    useEffect(() => {

        if (props?.fieldDetails) {
            let filterDetails = props?.fieldDetail.filter(item => item.module_name === 'Address Book')

            let field = filterDetails[0]?.sub_modules.filter(item => item.sub_module_name === 'Contacts')
            let data;
            if (field) {
                data = field[0]?.fields
            }
            if (data) {
                setContacts(data)
            }
        }
        if (props?.addressDetails) {
            const transformedAddressDetails = props?.addressDetails.map(detail => ({
                value: detail.address_name,
                label: detail.address_name
            }));
            setAddressDetails(transformedAddressDetails)
        }


    }, [props?.fieldDetail]);

    useEffect(() => {
        getCustomer();
        getBranchList();
        getCustomerDetail();
    }, [props?.customerId]);
    useEffect(() => {
        getBranchUsers();
    }, [branchId]);

    useEffect(() => {
        if (props?.contactDetail?.name_title) {
            titles?.filter(item => item == props?.contactDetail?.name_title ?
                setValue("name_title", item) : {})
        }
        if (props?.contactDetail?.role) {
            roles?.filter(item => item.label == props?.contactDetail?.role ?
                setValue("role", item) : {})
        }
        if (props?.contactDetail?.status) {
            status?.filter(item => item == props?.contactDetail?.status ?
                setValue("status", item) : {})
        }
        if (props?.contactDetail?.address_name) {
            addressDetails?.filter(item => item.label == props?.contactDetail?.address_name ?
                setValue("address_name", item) : {})
        }
        if (props?.contactDetail?.business_unit) {
            businessUnit?.filter(item => item.label == props?.contactDetail?.business_unit ?
                setValue("business_unit", item) : {})
        }
        if (props?.contactDetail?.owner) {
            branchDetail?.filter(item => item.label == props?.contactDetail?.owner ?
                setValue("owner", item) : {})
        }
        setValue('first_name', props?.contactDetail?.first_name)
        setValue('last_name', props?.contactDetail?.last_name)
        setValue('team_member_contact', props?.contactDetail?.team_member_contact)
        setValue('email', props?.contactDetail?.email)
        setValue('website', props?.contactDetail?.website)
        setValue('comment', props?.contactDetail?.comment)
        setValue('option_status', props?.contactDetail?.option_status)
    }, [props?.contactDetail]);

    const getCustomerDetail = async () => {
        try {
            setLoading(true)
            const response = await getCustomerDetails(props?.customerId);
            if (response && response.data) {
                const clientModuleData = response?.data?.reference_data.filter(item => item.option_names === 'BusinessUnit');
                let data;
                if (clientModuleData) {
                    data = clientModuleData[0]?.option_choice.filter(item => item.status == 'active');
                }
                setBusinessUnit(data)
            }
        } catch (error) {
            toastRef.current.showToast({
                type: "error",
                message: "An error occurred. Please try again or contact Admin.",
            });
        } finally {
            setLoading(false)
        }

    };

    const getBranchList = async () => {
        // Ensure customerId is not null

        try {
            setLoading(true)
            if (props?.customerId !== null) {
                // Fetch customer data from the server
                const customerDataResponse = await list(props?.customerId, 'branch_name', -1);
                if (customerDataResponse && customerDataResponse.data) {
                    setBranchId(customerDataResponse?.data?.branch[0]?._id)
                }
            }
        } catch (error) {
            toastRef.current.showToast({
                type: "error",
                message: "An error occurred. Please try again or contact Admin.",
            });
        } finally {
            setLoading(false)
        }
    };

    const getBranchUsers = async () => {
        // Ensure customerId is not null

        try {
            setLoading(true)
            if (branchId !== null) {
                // Fetch customer data from the server
                const customerDataResponse = await getBranchUser(props?.customerId, branchId);
                if (customerDataResponse && customerDataResponse.data) {
                    setBranchDetail(customerDataResponse.data)
                }
            }
        } catch (error) {
            toastRef.current.showToast({
                type: "error",
                message: "An error occurred. Please try again or contact Admin.",
            });
        } finally {
            setLoading(false)
        }
    };

    const getCustomer = async () => {
        try {
            setLoading(true)
            if (props?.customerId !== null) {
                const response = await getCustomerFields(props?.customerId);
                if (response && response.data) {
                    let data = response.data.reference_data
                    let state = data.filter(item => item.option_names === 'Roles')
                    setRoles(state[0].option_choice)
                }
            }
        } catch (error) {
            toastRef.current.showToast({
                type: "error",
                message: "An error occurred. Please try again or contact Admin.",
            });
        } finally {
            setLoading(false)
        }
    }
    useEffect(()=>{
        setSize(props?.contactDetail?.consent_accept)
    },[props?.contactDetail?.consent_accept])
    const handleRadioChange = (e) => {
        if (e === "Yes") {
            const isConsentAccepted = true; // Convert "Yes" to true
            setSize(isConsentAccepted);
          } else if (e === "No") {
            const isConsentAccepted = false; // Convert "No" to false
            setSize(isConsentAccepted);
          } else {
            console.error("Unexpected value:", e);
          }
      };

    // Function to create new prompt
    const onSubmit = async (promptData) => {
        let data = promptData;
        data.role = data?.role?.label;
        data.business_unit = data?.business_unit?.label
        data.consent_accept = size
        data.associated = props?.contactDetail?.associated
        data.associated_id = props?.contactDetail?.associated_id
        data.associated_name = props?.contactDetail?.associated_name
        data.customer_id = props?.contactDetail?.customer_id
        data.creation_date = props?.contactDetail?.creation_date
        data.updated_date = props?.contactDetail?.updated_date
        data._id = props?.contactDetail?._id
        data.client_team = `${data.first_name}  ${data.last_name}`
        data.lead = props?.contactDetail?.lead
        data.full_name = `${data.first_name}  ${data.last_name}`
        try {
            const response = await updateContactFromPages(props?.contactDetail?.associated_id, data);

            if (response && response.data && response?.data.success) {
                toastRef.current.showToast({
                    type: "success",
                    message: response?.data.message,
                });
                closePopup();
            } else {
                toastRef.current.showToast({
                    type: "error",
                    message: response?.data.message,
                });
            }
        } catch (e) {
            toastRef.current.showToast({
                type: "error",
                message: "An error occurred. Please try again or contact Admin.",
            });
        } finally {
            closePopup();
        }
    };

    const closePopup = () => {
        reset();
        setVisible(false);
        props.onHide();
    };

    const renderFooter = () => {
        return (
            <div className="cancel-footer">
                <div className='align-center justify-end pb-0'>
                    <ButtonElement label="Cancel" className="cancel-new-button" onClick={() => { closePopup(); }} />
                    <ButtonElement type="submit" label="Save" className="save-button" onClick={handleSubmit(onSubmit)} />
                </div>
            </div>
        );
    }

    return (
        <div>
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <Dialog
                header={_.find(props.clientSectionsSummary, { section_name: "Edit Client's Team" })?.display_name}
                visible={props.visible}
                position={props.position}
                onHide={() => {
                    closePopup();
                }}
                footer={renderFooter()}
                className="width-40vw"
                draggable={false}
            >
                <div className="new-field">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        {
                            _.find(props.addressContactFields, { field_name: "Title" })?.field_status &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        {contacts[0]?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="name_title"
                                        control={control}
                                        // rules={{ required: "Location Name is required" }}
                                        defaultValue={props?.contactDetail?.name_title}
                                        render={({ field }) => (
                                            <SingleSelectElement
                                                id="name_title"
                                                {...field}
                                                name="label"
                                                options={(titles != undefined && titles.length > 0) ? titles : []}
                                                optionLabel="label"
                                                placeholder="-- Please select --"
                                                maxSelectedLabels={1}
                                                onChangeValue={(e) => { setValue('name_title', e.value) }}
                                                className="w-full"
                                            />
                                        )}
                                    />
                                    {/* {errors?.name_title && (
                                        <small className="text-red-500 ml-1 color_red_new">
                                            {errors?.name_title.message}
                                        </small>
                                    )} */}
                                </div>
                            </div>
                        }
                        {
                            _.find(props.addressContactFields, { field_name: "First Name" })?.field_status &&
                            <div className="form-group row align-items-center mt-0 mb-0" >
                                <div className="col-md-4 text-left pl-0">
                                    <label className="form-label text-left">
                                        {contacts[1]?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="first_name"
                                        defaultValue={props?.contactDetail?.first_name}
                                        rules={{ required: "First Name is required" }}
                                        control={control}
                                        render={({ field }) => (
                                            <InputTextElement id="first_name" {...field} />
                                        )}
                                    />
                                    {errors?.first_name && (
                                        <small className="text-red-500 ml-1 color_red_new">
                                            {errors?.first_name.message}
                                        </small>
                                    )}
                                </div>
                            </div>
                        }
                        {
                            _.find(props.addressContactFields, { field_name: "Last Name" })?.field_status &&
                            <div className="form-group row align-items-center mt-0 mb-0" >
                                <div className="col-md-4 text-left pl-0">
                                    <label className="form-label text-left">
                                        {contacts[2]?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="last_name"
                                        defaultValue={props?.contactDetail?.last_name}
                                        rules={{ required: "Last Name is required" }}
                                        control={control}
                                        render={({ field }) => (
                                            <InputTextElement id="last_name" {...field} />
                                        )}
                                    />
                                    {errors?.last_name && (
                                        <small className="text-red-500 ml-1 color_red_new">
                                            {errors?.last_name.message}
                                        </small>
                                    )}
                                </div>
                            </div>
                        }
                        {
                            _.find(props.commonFields, { field_name: "Role" })?.field_status &&
                            <div className="form-group row align-items-center mt-0 mb-0">
                                <div className="col-md-4 text-left pl-0">
                                    <label className="form-label text-left">
                                        {_.find(props.commonFields, { field_name: "Role" })?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="role"
                                        defaultValue={props?.contactDetail?.role}
                                        control={control}
                                        render={({ field }) => (
                                            <SingleSelectElement
                                                id="role"
                                                {...field}
                                                name="office_addr_contact"
                                                options={(roles != undefined && roles.length > 0) ? roles : []}
                                                optionLabel="label"
                                                placeholder="-- Please select --"
                                                maxSelectedLabels={1}
                                                onChangeValue={(e) => { setValue('role', e.value) }}
                                                className="w-full"
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                        }
                        {
                            _.find(props.addressContactFields, { field_name: "Mobile Number" })?.field_status &&
                            <div className="form-group row align-items-center mt-0 mb-0">
                                <div className="col-md-4 text-left pl-0">
                                    <label className="form-label text-left">
                                        {contacts[3]?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        id="team_member_contact"
                                        name="team_member_contact"
                                        defaultValue={props?.contactDetail?.team_member_contact}
                                        rules={{
                                            pattern: {
                                                value: /^[+]?\d{1,4}[-.\s]?\(?\d{1,4}\)?[-.\s]?\d{1,9}$/,
                                                message: "Mobile number is not valid"
                                            }
                                        }}
                                        control={control}
                                        render={({ field }) => (
                                            <InputTextElement id="team_member_contact" {...field} />
                                        )}
                                    />
                                    {errors?.team_member_contact && (
                                        <small className="text-red-500 ml-1 color_red_new">
                                            {errors?.team_member_contact.message}
                                        </small>
                                    )}
                                </div>
                            </div>
                        }
                        {
                            _.find(props.addressContactFields, { field_name: "Email" })?.field_status &&
                            <div className="form-group row align-items-center mb-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        {contacts[4]?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="email"
                                        defaultValue={props?.contactDetail?.email}
                                        rules={{
                                            required: "Email is required",
                                            pattern: {
                                                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                message: "Invalid email format",
                                            },
                                        }}
                                        control={control}
                                        render={({ field }) => (
                                            <InputTextElement id="email" {...field} />
                                        )}
                                    />
                                    {errors?.email && (
                                        <small className="text-red-500 ml-1 color_red_new">
                                            {errors?.email.message}
                                        </small>
                                    )}
                                </div>
                            </div>
                        }
                        {
                            _.find(props.addressContactFields, { field_name: "Status" })?.field_status &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        {contacts[5]?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="status"
                                        control={control}
                                        defaultValue={props?.contactDetail?.status}
                                        render={({ field }) => (
                                            <SingleSelectElement
                                                id="status"
                                                {...field}
                                                name="label"
                                                options={(status != undefined && status.length > 0) ? status : []}
                                                optionLabel="label"
                                                placeholder="-- Please select --"
                                                maxSelectedLabels={1}
                                                onChangeValue={(e) => { setValue('status', e.value) }}
                                                className="w-full"
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                        }
                        {
                            _.find(props.commonFields, { field_name: "Location Name" })?.field_status &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        {_.find(props.commonFields, { field_name: "Location Name" })?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="address_name"
                                        control={control}
                                        defaultValue={props?.contactDetail?.address_name}
                                        render={({ field }) => (
                                            <SingleSelectElement
                                                id="address_name"
                                                {...field}
                                                name="address_name"
                                                options={(addressDetails != undefined && addressDetails.length > 0) ? addressDetails : []}
                                                optionLabel="label"
                                                placeholder="-- Please select --"
                                                maxSelectedLabels={1}
                                                onChangeValue={(e) => { setValue('address_name', e.value) }}
                                                className="w-full"
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                        }
                        {
                            _.find(props.commonFields, { field_name: "Business Unit" })?.field_status &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        {_.find(props.commonFields, { field_name: "Business Unit" })?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="business_unit"
                                        control={control}
                                        defaultValue={props?.contactDetail?.business_unit}
                                        render={({ field }) => (
                                            <SingleSelectElement
                                                id="business_unit"
                                                {...field}
                                                name="label"
                                                options={(businessUnit != undefined && businessUnit.length > 0) ? businessUnit : []}
                                                optionLabel="label"
                                                placeholder="-- Please select --"
                                                maxSelectedLabels={1}
                                                onChangeValue={(e) => { setValue('business_unit', e.value) }}
                                                className="w-full"
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                        }
                        {
                            _.find(props.addressContactFields, { field_name: "Co-ordinator" })?.field_status &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        {contacts[6]?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="owner"
                                        control={control}
                                        defaultValue={props?.contactDetail?.owner}
                                        render={({ field }) => {
                                            const options =
                                                branchDetail?.map((branch) => ({
                                                    value: `${branch.firstname} ${branch.surname}`,
                                                    label: `${branch.firstname} ${branch.surname}`,
                                                })) || [];

                                            return (
                                                <SingleSelectElement
                                                    id="owner"
                                                    {...field}
                                                    name="firstname"
                                                    options={(options != undefined && options.length > 0) ? options : []}
                                                    optionLabel="label"
                                                    placeholder="-- Please select --"
                                                    maxSelectedLabels={1}
                                                    onChangeValue={(e) => { setValue('owner', e.value) }}
                                                    className="w-full"
                                                />
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                        }
                        {
                            _.find(props.addressContactFields, { field_name: "Website" })?.field_status &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        {contacts[7]?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        id="website"
                                        name="website"
                                        defaultValue={props?.contactDetail?.website}
                                        control={control}
                                        rules={{
                                            pattern: {
                                                value:
                                                    /[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/,
                                                message: "Invalid URL format",
                                            },
                                        }}
                                        render={({ field }) => (
                                            <InputTextElement id="website" {...field} />
                                        )}
                                    />
                                    {errors?.website && (
                                        <small className="text-red-500 ml-1 color_red_new">
                                            {errors?.website.message}
                                        </small>
                                    )}
                                </div>
                            </div>
                        }
                        {
                            _.find(props.addressContactFields, { field_name: "Comments" })?.field_status &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        {contacts[8]?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="comment"
                                        defaultValue={props?.contactDetail?.comment}
                                        control={control}
                                        render={({ field }) => (
                                            <InputTextElement id="comment" {...field} />
                                        )}
                                    />
                                </div>
                            </div>
                        }
                        {
                            _.find(props.addressContactFields, { field_name: "GDPR Consent Received" })?.field_status &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        {contacts[9]?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <RadioElement
                                        id="option_status"
                                        value={size ? "Yes" : "No"} 
                                        // defaultValue={props?.contactDetail?.consent_accept ? "Yes" : "No"}
                                        options={[
                                            { key: "Yes", name: "Yes" },
                                            { key: "No", name: "No" },
                                        ]}
                                        onChangeRadio={handleRadioChange}
                                        className="radio-group-class" // Add any additional classes if necessary
                                    />
                                </div>
                            </div>
                        }
                    </form>
                </div>
            </Dialog>
        </div>
    );
}
